(function () {
  'use strict';

  angular.module('settings.customization.custom.field', [
    'ui.router',
    'ngResource',
  ]);
})();
